import React from 'react';
import Select from 'react-select';
import { LeagueIcons, LeagueIconsMeta } from '../data/LeagueIcons';
import { customDarkSelectStyles } from './CustomDarkSelectStyles';

const LeagueCustomSelect = ({ options, selectedOption, onOptionChange }) => {
  const customOption = ({ innerProps, label, value, isFocused }) => (
    <div
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: isFocused ? '#3a3a3a' : '#2c2c2c',
        color: '#f1f1f1',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#4a4a4a')}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = isFocused ? '#3a3a3a' : '#2c2c2c')}
    >
      <img style={{ filter: LeagueIconsMeta[label] === 1 ? "invert(1)" : "none", width: '20px', height: '20px', borderRadius: '3px', objectFit: 'contain', }}
        src={LeagueIcons[label]} alt="" />
      {label}
    </div>
  );

  return (
    <Select
      hideSelectedOptions={selectedOption.length < 3 ? true : false}
      placeholder="League"
      isMulti
      options={options}
      onChange={(selectedOptions) => onOptionChange(selectedOptions)}
      value={selectedOption}
      components={{ Option: customOption }}
      styles={customDarkSelectStyles}
    />
  );
};

export default LeagueCustomSelect;
